export class DeletePageErrorEffect {
  public static readonly type = '[Project/Wiki/List] DeletePageErrorEffect';
  constructor(public readonly error: Error) {}
}
